import { WORK_ORDER_STATUS } from 'src/api/constants/workOrder'
import type { WorkOrder } from 'src/api/domains/service-tracking/serviceTracking.types'

import { TREATMENT_BUCKET, type TreatmentBucket, TreatmentStatus } from '../constants/treatment'

/** Determines whether a treatment entry is in progress, excluded, or completed. */
export const resolveTreatmentBucket = (
  status: TreatmentStatus,
  workOrderStatusSlug?: WorkOrder['status']['slug'],
): TreatmentBucket => {
  if (
    [
      TreatmentStatus.NotApproved,
      TreatmentStatus.NotCovered,
      TreatmentStatus.Declined,
      TreatmentStatus.Voided,
    ].includes(status)
  )
    return TREATMENT_BUCKET.EXCLUDED
  if (
    [TreatmentStatus.Covered, TreatmentStatus.Paid, TreatmentStatus.Approved].includes(status) &&
    workOrderStatusSlug === WORK_ORDER_STATUS.COMPLETED
  )
    return TREATMENT_BUCKET.COMPLETED

  return TREATMENT_BUCKET.IN_PROGRESS
}
